import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Order';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $create = ActionCreator.Async(MODULE, 'Create', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/delivery/order`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/order`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/order/${id}`, payload)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $getByInvoice = ActionCreator.Async(MODULE, 'GetByInvoice', (id) => {
  return async (dispatch) => {
    dispatch($processing($getByInvoice.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/order/${id}/invoice`)
      .then((response) => {
        dispatch($getByInvoice.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getByInvoice.OPERATION)));
  };
});

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/order/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/delivery/order/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});

export const $void = ActionCreator.Async(MODULE, 'Void', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/order/${id}/void`, payload)
      .then((response) => {
        dispatch($void.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $paid = ActionCreator.Async(MODULE, 'Paid', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/order/${id}/paid`, payload)
      .then((response) => {
        dispatch($paid.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $reorder = ActionCreator.Async(
  MODULE,
  'Reorder',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(
        `${API_URL}/tms/delivery/order/${id}/reorder`,
        payload
      )
        .then((response) => {
          dispatch($reorder.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $updatePrice = ActionCreator.Async(
  MODULE,
  'Update.Price',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/delivery/order/${id}/update/price`,
        payload
      )
        .then((response) => {
          dispatch($updatePrice.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);


export const $restore = ActionCreator.Async(
  MODULE,
  'Restore',
  (id) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/delivery/${id}/restore`, {})
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
